import React from 'react';

import { PageSegmentLoadStart } from '@confluence/browser-metrics/entry-points/PageSegmentLoadStart';
import { fg } from '@confluence/feature-gating';
import { ExperienceStart } from '@confluence/experience-tracker/entry-points/component';
import { SHARE_AND_RESTRICT_BUTTON_LOAD_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName';

import { SHARE_BUTTON_PAGE_SEGMENT_LOAD } from './perf.config';
import type { ShareRestrictAndCopyCoordinatorProps as ShareAndRestrictButtonProps } from './shareAndRestrictButton/ShareRestrictAndCopyCoordinator';
import {
	ShareAndRestrictButtonLoader,
	ShareAndRestrictButtonSSRLoader,
} from './ShareAndRestrictButtonLoader';

export const ShareAndRestrictButton = (props: Omit<ShareAndRestrictButtonProps, 'flags'>) => (
	<>
		<PageSegmentLoadStart
			metric={SHARE_BUTTON_PAGE_SEGMENT_LOAD}
			isCustomStart
			key={props.contentId}
		/>
		<ExperienceStart name={SHARE_AND_RESTRICT_BUTTON_LOAD_EXPERIENCE} />
		{!fg('confluence_frontend_content_wrapper') ? (
			<ShareAndRestrictButtonLoader {...props} />
		) : fg('confluence_frontend_usd_ssr') ? (
			<ShareAndRestrictButtonSSRLoader {...props} />
		) : (
			<ShareAndRestrictButtonLoader {...props} />
		)}
	</>
);
